(function() {
  'use strict';

  var ALL_FLAG_KEYS = ['Confezione regalo', 'Gift wrap', 'Gift Message'];
  var ALL_NOTE_KEYS = ['Messaggio regalo', 'Gift message', 'Gift Note'];
  var DEBOUNCE_MS = 400;
  var timers = {};
  var warnedMissingLine = false;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function originalTarget(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : null;
    return path && path.length ? path[0] : event.target;
  }

  function matches(element, selector) {
    return !!(element && element.matches && element.matches(selector));
  }

  function getBox(element) {
    return element && element.closest ? element.closest('[data-gift-message]') : null;
  }

  function toggleWrapper(box) {
    var checkbox = box.querySelector('[data-gift-toggle]');
    var wrapper = box.querySelector('.gift-message-wrapper');

    if (!checkbox || !wrapper) {
      return;
    }

    wrapper.style.display = checkbox.checked ? 'block' : 'none';
  }

  function persist(box) {
    var line = parseInt(box.getAttribute('data-line'), 10);

    if (!line) {
      if (!warnedMissingLine) {
        warnedMissingLine = true;
        console.warn('Gift message: data-line is missing. Check that cart-drawer.liquid and main-cart.liquid pass line_index: forloop.index.');
      }
      return Promise.resolve();
    }

    var flagKey = box.getAttribute('data-gift-flag-key') || ALL_FLAG_KEYS[0];
    var noteKey = box.getAttribute('data-gift-note-key') || ALL_NOTE_KEYS[0];
    var flagValue = box.getAttribute('data-gift-flag-value') || 'Yes';
    var checkbox = box.querySelector('[data-gift-toggle]');
    var noteInput = box.querySelector('[data-gift-note]');
    var isGift = !!(checkbox && checkbox.checked);
    var note = noteInput ? noteInput.value.trim() : '';

    return fetch(rootUrl() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      var lineItem = cart.items[line - 1];
      if (!lineItem) {
        return null;
      }
      var properties = Object.assign({}, lineItem.properties || {});

      ALL_FLAG_KEYS.forEach(function(key) {
        delete properties[key];
      });
      ALL_NOTE_KEYS.forEach(function(key) {
        delete properties[key];
      });

      if (isGift) {
        properties[flagKey] = flagValue;
        if (note) {
          properties[noteKey] = note;
        }
      }

      /* An empty properties object is a no-op for Shopify's cart/change.js (it leaves
      existing properties untouched), so clearing every gift key still needs a
      non-empty payload. Fall back to a single underscore-prefixed key, which
      Shopify and this theme already treat as hidden everywhere. */
      if (Object.keys(properties).length === 0) {
        properties['_gift'] = '';
      }

      return fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: line,
          properties: properties
        })
      });
    })
    .then(function() {
      box.removeAttribute('data-gift-dirty');
      box.removeAttribute('data-gift-needs-migration');
    })
    .catch(function(error) {
      console.error('Gift message could not be saved to the cart.', error);
    });
  }

  function schedulePersist(box) {
    var key = box.getAttribute('data-line') || '0';
    box.setAttribute('data-gift-dirty', 'true');
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function() {
      persist(box);
    }, DEBOUNCE_MS);
  }

  function persistNow(box) {
    clearTimeout(timers[box.getAttribute('data-line') || '0']);
    box.setAttribute('data-gift-dirty', 'true');
    return persist(box);
  }

  function migrateIfNeeded(box) {
    if (box.getAttribute('data-gift-needs-migration') === 'true') {
      persistNow(box);
    }
  }

  function scanForMigrations(root) {
    var scope = root || document;
    var boxes = scope.querySelectorAll ? scope.querySelectorAll('[data-gift-message][data-gift-needs-migration="true"]') : [];
    Array.prototype.forEach.call(boxes, migrateIfNeeded);
  }

  document.addEventListener('change', function(event) {
    var target = originalTarget(event);
    var box = getBox(target);
    if (!box || !matches(target, '[data-gift-toggle]')) {
      return;
    }
    toggleWrapper(box);
    schedulePersist(box);
  }, true);

  document.addEventListener('click', function(event) {
    var target = originalTarget(event);
    var box = getBox(target);
    if (box) {
      var fromToggle = matches(target, '[data-gift-toggle]') || (target.closest && target.closest('.gift-checkbox'));
      if (fromToggle) {
        setTimeout(function() {
          toggleWrapper(box);
          schedulePersist(box);
        }, 0);
      }
    }
  }, true);

  document.addEventListener('input', function(event) {
    var target = originalTarget(event);
    var box = getBox(target);
    if (!box || !matches(target, '[data-gift-note]')) {
      return;
    }
    schedulePersist(box);
  }, true);

  document.addEventListener('blur', function(event) {
    var target = originalTarget(event);
    var box = getBox(target);
    if (!box || !matches(target, '[data-gift-note]')) {
      return;
    }
    if (box.hasAttribute('data-gift-dirty')) {
      persistNow(box);
    }
  }, true);

  document.addEventListener('keydown', function(event) {
    var target = originalTarget(event);
    if (event.key !== 'Enter' || !matches(target, '[data-gift-note]')) {
      return;
    }
    event.preventDefault();
    target.blur();
  });

  document.addEventListener('click', function(event) {
    var target = originalTarget(event);
    var trigger = target.closest ? target.closest('[name="checkout"], [href*="/checkout"]') : null;
    if (trigger) {
      var pending = document.querySelectorAll('[data-gift-message][data-gift-dirty]');
      if (pending.length) {
        event.preventDefault();
        event.stopPropagation();
        Promise.all(Array.prototype.map.call(pending, persistNow)).then(function() {
          trigger.click();
        });
      }
    }
  }, true);

  scanForMigrations(document);

  var giftMigrationObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function(node) {
        if (node.nodeType === 1) {
          if (matches(node, '[data-gift-message]')) {
            migrateIfNeeded(node);
          }
          scanForMigrations(node);
        }
      });
    });
  });
  giftMigrationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();